module.exports = __webpack_public_path__ + "static/media/failed-capture-four.62b8aa41.png";